<template>
  <div>
    <!-- BootstrapVue Modal component for the transaction details -->
    <!-- TODO: Add different title for the modal whether the payment was successful or not  -->
    <b-modal v-model="isModalVisible" hide-footer title="FAIR DONATION" @hide="clearUrlParams">
      <!-- TODO: Add different title for the modal whether the payment was successful or not  -->
      <h3 class="my-4 text-center">Kiitos lahjoituksestasi!</h3>
      <!-- <p class="text-center">tähän kuva</p> -->
      <p class="text-center">Kampanja: <strong>{{ campaign }}</strong></p>
      <p class="text-center">Summa: <strong>{{ amount }} </strong></p>
    </b-modal>
    <b-modal v-model="isCanceledModalVisible" hide-footer title="FAIR DONATION" @hide="clearUrlParams">
      <h3 class="my-4 text-center">Jotain meni pieleen!</h3>
      <p class="text-center">Syy: <strong>{{ campaign }}</strong></p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      campaign: null,
      isModalVisible: false,
      isCanceledModalVisible: false,
      amount: null,
      id: null
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const campaign = urlParams.get('campaign');

    if(!campaign) return;

    const jsonString = atob(campaign);
    const data = JSON.parse(jsonString);

    const paymentSuccessful = data.statusCode === 'success';

    if (campaign && paymentSuccessful && data.campaign !== null) {
      try {
        const dataAsEuros = data.amount / 100;
          this.campaign = data.campaign;
          this.amount = `${dataAsEuros}€`;
          this.id = data.id;
          this.isModalVisible = true;
        
      } catch (error) {
        // Handle errors such as invalid Base64 or JSON
        console.error('Failed to parse campaign data:', error);
        this.isModalVisible = false
        this.modalMessage = 'An unexpected error occurred.';
      }
    }
    if(campaign && !paymentSuccessful && data.statusCode) {
      this.isCanceledModalVisible = true;
      const isCanceled = data.statusCode === 'canceled';
        this.campaign = isCanceled ? 'Lahjoitus peruutettu' : 'Lahjoitus epäonnistui';
    }
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    },
    clearUrlParams() {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
};

</script>

<style scoped>
/* Scoped styling can be added here if needed */
</style>